import { render } from "./DeleteModalDialog.vue?vue&type=template&id=1de4c271&scoped=true"
import script from "./DeleteModalDialog.vue?vue&type=script&lang=js"
export * from "./DeleteModalDialog.vue?vue&type=script&lang=js"

import "./DeleteModalDialog.vue?vue&type=style&index=0&id=1de4c271&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de4c271"]])

export default __exports__